<template>
    <div class="widgetContainer">
        <span class="widgetTitle">{{getTitle()}}</span>
        <!-- Widget elements here -->
        <div class="align-self-start">
            <button class="closeButton" v-on:click="$emit('close-widget')">
                <font-awesome-icon class="closeButtonIcon" icon="window-close" size="xs"/>
            </button>
        </div>
    </div>
</template>
<script>
  // import DxContextMenu from 'devextreme-vue/context-menu';
  
  export default {
    name: "WidgetLastFiveChecks",

    mixins: [],

    components:{
    },

    props: {
      widgetdata: { type: Object, default: null },
      colors: { type: Array,
        default: () => {
          return [
            {"name":"red","color":"#FF1500","imageAsset":null,"min":0,"max":79},
            {"name":"yellow","color":"#FFD800","imageAsset":null,"min":80,"max":89},
            {"name":"green","color":"#4CFF00","imageAsset":null,"min":90,"max":100}
          ]
        }
      },
    },

    created() {
      // console.log('WidgetLastFiveChecks - created');
    },

    mounted(){
      // console.log('WidgetLastFiveChecks - mounted');
    },

    beforeDestroy() {
      // console.log('WidgetLastFiveChecks - beforeDestroy');
    },

    data() {
      return {
      }
    },

    methods: {
        getTitle() {
            // console.log('WidgetTotalScore - getTitle');
            return this.widgetdata ? this.widgetdata.Title : "Last five checks:";
        },
    },

    computed: {
    }
  }
</script>
<style>
</style>